import { render, staticRenderFns } from "./Objetivo.vue?vue&type=template&id=27d3d2b1&scoped=true"
import script from "./Objetivo.vue?vue&type=script&lang=js"
export * from "./Objetivo.vue?vue&type=script&lang=js"
import style0 from "./Objetivo.vue?vue&type=style&index=0&id=27d3d2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d3d2b1",
  null
  
)

export default component.exports